module.exports = __webpack_public_path__ + "img/Prudence_text03_compare.d632ec09.png";